<template>
  <div class="d-flex align-center partner-card-badge">
    <span
      class="partner-badge text-caption font-italic grey--text"
      :class="badgeClass"
    >
      {{ label }}
    </span>
    <PartnerFeedbackMenu
      v-if="interactive && cardId"
      :card-id="cardId"
    />
  </div>
</template>

<script>
import PartnerFeedbackMenu from './PartnerFeedbackMenu.vue';
import appName from '@/helpers/appName';

export default {
  name: 'PartnerCardBadge',

  components: { PartnerFeedbackMenu },

  props: {
    cardId: {
      type: Number,
      default: null,
    },
    interactive: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: `A trusted ${appName()} Partner`,
    },
    badgeClass: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.partner-card-badge {
  width: 100%;
}

.v-application .partner-badge {
  display: inline;
  line-height: 1.1 !important;
  flex: 1;
}

.partner-badge--small {
  text-align: right;
}
</style>
